module.exports = __webpack_public_path__ + "static/media/galerija_2015 (2).842a2df8.JPG";